var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { class: [{ "margin-bottom-5xl": !_vm.isLast }] },
    [
      _c(
        "ais-instant-search",
        {
          ref: "instantSearch",
          attrs: {
            "index-name": _vm.index,
            "insights-client": _vm.insightsClient,
            middlewares: _vm.middlewares,
            "search-client": _vm.searchClient,
            "search-parameters": { clickAnalytics: true },
          },
        },
        [
          _c("ais-configure", {
            ref: "configure",
            attrs: {
              distinct: true,
              facetFilters: _vm.facetFilters,
              hitsPerPage: _vm.pageSize,
              page: _vm.page,
            },
          }),
          _vm._v(" "),
          _c("ais-stats", [
            _c(
              "div",
              {
                staticClass:
                  "row roomy align-middle align-between margin-bottom-xl",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "column-12 tablet:column-8 margin-bottom-sm tablet:margin-bottom-0",
                  },
                  [_c("h3", [_vm._v(_vm._s(_vm.familyStyleLabel))])]
                ),
                _vm._v(" "),
                _vm.visualTags
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "column-12 tablet:column-4 tablet:text-right display-flex flex-items-center tablet:flex-content-end",
                        staticStyle: { gap: "var(--spacing-sm)" },
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              "aria-label": `Icon Types in ${_vm.familyStyleLabel}`,
                              "data-balloon-pos": "up",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "margin-right-3xs",
                              attrs: { icon: _vm.$v6.solid.faTag },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.visualTags, function (visualTag, idx) {
                          return _c(
                            "site-link",
                            {
                              key: idx,
                              staticClass: "size-sm",
                              staticStyle: {
                                "--link-color":
                                  "var(--theme-action-primary-dk)",
                                "--link-hover-color":
                                  "var(--theme-action-primary)",
                              },
                              attrs: {
                                to: _vm.$search({ iconTypes: visualTag }),
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.startCaseString(visualTag)) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("icon-list", {
            ref: "iconList",
            attrs: {
              "selected-family": _vm.selectedFamily,
              "selected-style": _vm.selectedStyle,
              "is-pro-user": _vm.isProUser,
              "selected-icon-id": _vm.selectedIconId,
              version: _vm.version,
              "search-field-focus": _vm.searchFieldFocus,
              "results-view": "compact",
            },
            on: { toggleIcon: _vm.toggleIcon, closeIcon: _vm.closeIcon },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }